







import Vue from 'vue';
import {Prop} from 'vue-property-decorator';
import Component from 'vue-class-component';
import {COLOR_SERVICE_INSTANCE} from '@/services/style/color.service';
import FTEnumHeadline = DisguiseDto.FTEnumHeadline;
import EnumColor = DisguiseDto.EnumColor;

@Component({
  name: 'Headline',
  components: {}
})
export default class AmetrasHeadlineFieldTemplate extends Vue {
  @Prop() label!: string;
  @Prop() headline!: FTEnumHeadline;
  @Prop() headlineColor!: EnumColor;

  get textColor() {
    return COLOR_SERVICE_INSTANCE.getColor(this.headlineColor, 'FOREGROUND',
        this.$vuetify.theme.dark, false);
  }
}
